// Deprecated. Please refrain from new usage
import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "@material-ui/core";
import { withTheme } from "@material-ui/core/styles";
import SPScrollbar from "../Navigation/SPScrollbar";
import WorkflowHeader from "./WorkflowHeader";

export const WorkflowWrapper = ({ theme, children, headerImage, title, ...otherProps }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const headerHeight = isMobile ? 74 : 60;
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
      }}
      {...otherProps}
    >
      <WorkflowHeader image={headerImage} title={title} headerHeight={headerHeight} />
      <SPScrollbar
        contentProps={{
          style: {
            marginTop: headerHeight,
            height: `calc(100% - ${headerHeight}px`,
          },
        }}
      >
        {children}
      </SPScrollbar>
    </div>
  );
};

WorkflowWrapper.propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  headerImage: PropTypes.string,
  title: PropTypes.string,
};

WorkflowWrapper.defaultProps = {
  headerImage: null,
  title: null,
};

export default withTheme(WorkflowWrapper);

/*
  This wrapper component should be used on all views that require a 'workflow
  header' (a simple header with a title, an image or back button). Currently this
  includes LoginContainer.jsx, EnterEmail.jsx, CreateNewPassword.jsx, RouteEditor.jsx
 */
